import Page from 'components/Page';
import React, { useEffect, useState } from 'react';
import Loader from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import { getUser } from 'redux/selectors';
import Account from './Account';
import Billing from './Billing';
import Brands from './Brands';
import TeamMembers from './TeamMembers';

const SettingsSidebar = ({ active, setActive, user }) => {
  return (
    <aside class="menu">
      <p class="menu-label">General</p>
      <ul class="menu-list">
        <li>
          <a
            onClick={() => {
              setActive('Account');
              window.history.replaceState(null, 'Account', '/settings/account');
            }}
            class={`${active === 'Account' ? 'is-active' : ''}`}
          >
            <i class="fas fa-user-circle margin-right-5" /> Account
          </a>
        </li>
        {user.role === 'owner' && !user.svCustomer && (
          <li>
            <a
              onClick={() => {
                setActive('Subscription and Billing');
                window.history.replaceState(
                  null,
                  'Subscription and Billing',
                  '/settings/billing'
                );
              }}
              class={`${
                active === 'Subscription and Billing' ? 'is-active' : ''
              }`}
            >
              <i class="fas fa-credit-card margin-right-5" /> Subscription and
              Billing
            </a>
          </li>
        )}
        {['owner', 'admin'].includes(user.role) && (
          <li>
            <a
              onClick={() => {
                setActive('Brand Identities');
                window.history.replaceState(
                  null,
                  'Billing',
                  '/settings/brands'
                );
              }}
              class={`${active === 'Brand Identities' ? 'is-active' : ''}`}
            >
              <i class="fas fa-swatchbook margin-right-5" /> Brand Identities
            </a>
          </li>
        )}

        {['owner', 'admin'].includes(user.role) && (
          <li>
            <a
              onClick={() => {
                setActive('Team Members');
                window.history.replaceState(
                  null,
                  'Team Members',
                  '/settings/members'
                );
              }}
              class={`${active === 'Team Members' ? 'is-active' : ''}`}
            >
              <i class="fas fa-users margin-right-5" /> Team Members
            </a>
          </li>
        )}
      </ul>
    </aside>
  );
};

const Settings = (props) => {
  const [active, setActive] = useState(props.active || 'Account');
  const [inviteModal, showInviteModal] = useState(false);
  const [brandModal, showBrandModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const user = useSelector(getUser);

  useEffect(() => {
    if (user.svCustomer && window.location.pathname == '/settings/billing') {
      window.location.href = '/settings/account';
    }
  }, []);

  useEffect(() => {
    if (user) setLoading(false);
  }, [user]);

  const actionButton = () => {
    switch (active) {
      case 'Team Members': {
        return (
          <button
            aria-haspopup="true"
            aria-controls="dropdown-menu"
            className="button upload is-info is-small action_button"
            onClick={(e) => showInviteModal(true)}
          >
            <span class="icon">
              <i class="menu far fa-paper-plane" />
            </span>
            <span>Invite colleague</span>
          </button>
        );
      }
      case 'Brand Identities': {
        return (
          <button
            aria-haspopup="true"
            aria-controls="dropdown-menu"
            className="button upload is-info is-small action_button"
            onClick={(e) => showBrandModal(true)}
          >
            <span class="icon">
              <i class="menu fa fa-plus" />
            </span>
            <span>New Brand Identity</span>
          </button>
        );
      }
      default:
        return null;
    }
  };
  const renderLoading = () => {
    return (
      <div className="fullwidth_loader_container">
        <Loader type="Oval" color="#ccc" height={30} width={30} />
      </div>
    );
  };
  const renderContent = () => {
    return (
      <div class="container">
        <div className="box page-box">
          <div class="columns">
            <div class="column">
              <SettingsSidebar
                user={user}
                active={active}
                setActive={setActive}
              />
            </div>
            <div class="column is-three-quarters">
              {active === 'Account' && <Account />}
              {active === 'Subscription and Billing' && !user.svCustomer && (
                <Billing />
              )}
              {active === 'Subscription and Billing' && user.svCustomer && (
                <Account />
              )}
              {active === 'Brand Identities' && (
                <Brands newModal={brandModal} setNewModal={showBrandModal} />
              )}
              {active === 'Team Members' && (
                <TeamMembers
                  inviteModal={inviteModal}
                  showInviteModal={showInviteModal}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <Page title={active} action={actionButton()}>
      <div className="page settings_page">
        {loading ? renderLoading() : renderContent()}
      </div>
    </Page>
  );
};

export default Settings;
